import { ROLE_ID_MEMBER, ROLE_ID_MANAGER, ROLE_ID_OWNER } from './../../../features/workbench-info/workbench.constants';
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { RespTeamStatics } from '@vas2t-lowcode/api';

/**
 * 工作区相关
 */
export const usePTeamStore = defineStore('team', () => {
  /** 工作区数据信息 */
  const statics = ref<RespTeamStatics | null>(null);
  /** 数据加载状态 */
  const isInitStaticsData = ref(false);

  /** 全部应用弹窗显示状态— 方便埋点使用 */
  const isShowAllAppDialog = ref(false);

  /** 工作区是否显示 */
  const isShowWorkbench = computed(() => {
    return statics.value && Object.keys(statics.value).length;
  });

  /** 是否为工作区创建者 */
  const isWorkbenchOwner = computed(() => {
    return statics.value?.curr_team_info?.role_id === ROLE_ID_OWNER;
  });

  /** 是否为工作区管理员 */
  const isWorkbenchManager = computed(() => {
    return statics.value?.curr_team_info?.role_id === ROLE_ID_MANAGER;
  });

  /** 是否拥有高级权限 */
  const hasTopPermission = computed(() => {
    return isWorkbenchOwner.value || isWorkbenchManager.value;
  });

  /** 是否为工作区成员 */
  const isWorkbenchMember = computed(() => {
    return statics.value?.curr_team_info?.role_id === ROLE_ID_MEMBER;
  });

  /** 是否为工作区成员 */
  const isTeamUserDisabled = computed(() => {
    return !statics.value?.curr_team_info?.is_enable;
  });

  /** 工作区id */
  const workbenchId = computed(() => {
    return statics.value?.curr_team_info?.team_id;
  });

  function setStatics(data: RespTeamStatics) {
    /** 更新数据 */
    statics.value = data;

    /** 标记数据加载完成状态 */
    isInitStaticsData.value = true;
  }

  /** 更新数据状态初始化 */
  function setIsInitStaticsData(val: boolean) {
    /** 标记数据加载完成状态 */
    isInitStaticsData.value = val;
  }

  /** 切换显示全部应用弹窗 */
  function toggleShowAllAppDialog(val: boolean) {
    isShowAllAppDialog.value = val;
  }

  return {
    statics,
    isShowAllAppDialog,
    isShowWorkbench,
    isInitStaticsData,
    isWorkbenchOwner,
    isWorkbenchManager,
    isWorkbenchMember,
    hasTopPermission,
    workbenchId,
    setStatics,
    setIsInitStaticsData,
    toggleShowAllAppDialog,
    isTeamUserDisabled,
  };
});
